var exports = {
  "C9": "NekoSprite.module__neko___dC1jNE",
  "Hm": "NekoSprite.module__heart___dC1jNE",
  "kn": "NekoSprite.module__nekoHeartFloat___dC1jNE",
};

module.exports = exports;
